import Page from "@/lib/components/Page";
import Center from "@/lib/components/Center";
import ErrorMessage from "@/lib/components/ErrorMessage";
import {useQueryClient} from "@tanstack/react-query";
import ActionButton from "@/lib/components/ActionButton";
import Nav from "@/lib/components/Nav";
import {useRouter} from "expo-router";
import {BackendError} from "@/lib/types";
import Header from "@/lib/components/Header";

type Props = {
    error: Error,
}

// Outer wrapper container for all pages.
export default function ErrorPage({error}: Props) {
    const queryClient = useQueryClient();
    const router = useRouter();

    async function reset() {
        await queryClient.invalidateQueries();
    }

    const backendError = error as BackendError;
    const isUnauthenticated = backendError.status === 403;
    const isRatelimit = backendError.status === 429;
    const isServerError = backendError.status === 503;
    const isRetryable = error.name !== "ApiError" || isRatelimit || isServerError;

    return (
        <Page>
            <Center>
                <Header center={true} title={"Feil"}/>
                <ErrorMessage error={error}/>
                <Nav>
                    {isUnauthenticated && <ActionButton title={"Gå til innlogging"} onPress={() => router.navigate(`/u/account/login`)}/>}
                    {isRetryable && <ActionButton title={"Prøv igjen"} onPress={reset}/>}
                </Nav>
            </Center>
        </Page>
    );
}